import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setPopupState } from '../../model/configuratorSlice';
import { CloseButton } from '../../shared/svg/components';
import { PopupState, UnitStatus } from '../../model/constants';
import { TranslationUtility } from '../../utilities/TranslationUtility';
import UnitService from '../../services/UnitService';
import DownloadPdfService from '../../services/DownloadPdfService';

const CheckDownloadPdfPopup = () => {
  const { popupState, currentUnit, isLoadingUnitStatus } = useSelector(state => state.configurator);
  const dispatch = useDispatch();

  const unitMutation = UnitService();
  const downloadPdfMutation = DownloadPdfService();

  const isCheckForDownloadPdfPopupOpened = popupState === PopupState.CheckForDownloadPdf;

  const closePopupHandler = () => {
    dispatch(setPopupState(PopupState.None));
  };

  const continueDownloadingPdf = () => {
    downloadPdfMutation.mutate();
    closePopupHandler();
  };

  // Load latest unit status when popup opens (like RequestBudgetPopup)
  useEffect(() => {
    if (isCheckForDownloadPdfPopupOpened) {
      unitMutation.mutate();
    }
  }, [isCheckForDownloadPdfPopupOpened]);

  // When data is ready, decide what to do
  useEffect(() => {
    if (!isCheckForDownloadPdfPopupOpened) return;
    if (isLoadingUnitStatus) return;
    if (!currentUnit) return;

    const isBudgetRequested = currentUnit.status === UnitStatus.BudgetRequested;

    if (!isBudgetRequested) {
      // Allowed to save: trigger the save and close popup
      downloadPdfMutation.mutate();
      closePopupHandler();
    }
  }, [isCheckForDownloadPdfPopupOpened, isLoadingUnitStatus, currentUnit]);

  if (!isCheckForDownloadPdfPopupOpened) return null;

  if (isLoadingUnitStatus) return null; // <MainLoader />;

  const isBudgetRequested = currentUnit && currentUnit.status === UnitStatus.BudgetRequested;

  return (
    <div className={`check-popup ${isCheckForDownloadPdfPopupOpened ? 'opened' : ''}`}>
      {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
      <button
        className={`background ${isCheckForDownloadPdfPopupOpened ? 'opened' : ''}`}
        type="button"
        onClick={closePopupHandler}
      />
      <div className={`panel ${isCheckForDownloadPdfPopupOpened ? 'opened' : ''}`}>
        <div className="header">
          {TranslationUtility.GetFormattedMessageForUI('ui-save-panel-title', 'Descargar resumen')}
        </div>
        {isBudgetRequested ? (
          <>
            <div className="sub-header">
              {TranslationUtility.GetFormattedMessageForUI(
                'ui-save-panel-status-already-formalized',
                // eslint-disable-next-line max-len
                'Esta vivienda ya ha sido formalizada. ¿Desea descargar el resumen de la configuración original?',
              )}
            </div>
            <div className="container-buttons">
              <button
                className="check-button"
                type="button"
                onClick={continueDownloadingPdf}
              >
                <span>
                  {TranslationUtility.GetFormattedMessageForUI('ui-logout-panel-button', 'Aceptar')}
                </span>
              </button>
            </div>
          </>
        ) : (
          // If saving is allowed, the effect above will auto-save and close; keep UI minimal
          <div className="sub-header">
            {TranslationUtility.GetFormattedMessageForUI('ui-save-panel-subtitle', 'Guardando configuración…')}
          </div>
        )}
        <button
          type="button"
          className="close-button"
          onClick={closePopupHandler}
        >
          <CloseButton className="icon" />
        </button>
      </div>
    </div>
  );
};

export default CheckDownloadPdfPopup;
